<div class="wallet-selector-container">
    <form #interceptorForm="ngForm" name="interceptorForm" novalidate (ngSubmit)="save()">
        <div class="wallet-selector-header center-text bold bottom-spacer">{{ sitecore.betslip.wallet.WalletSelectorTitle }}</div>
        <div class="wallet-selector-sub-heading center-text bottom-spacer">{{ sitecore.betslip.wallet.WalletSelectorSubHeading1 }}</div>
        <div class="wallet-selector-sub-heading center-text bottom-spacer">{{ sitecore.betslip.wallet.WalletSelectorSubHeading2 }}</div>
        <div class="wallet-selector-wallet-container">
            @for (wallet of accountBalanceService.availableWallets | async; track wallet.type) {
                <div class="wallet-item">
                    <ds-radio-group size="medium" name="walletRadioGroup" [(ngModel)]="selectedWalletType">
                        <ds-radio-button name="selectedWallet" [value]="wallet.type">
                            <div>
                                <span class="wallet-balance bold">{{ wallet.amount | msCurrency: true }}</span>
                                <p class="wallet-selector-wallet-title">{{ wallet.title }}</p>
                            </div>
                        </ds-radio-button>
                    </ds-radio-group>
                </div>
            }
        </div>
        <div class="wallet-selector-confirm bottom-spacer">
            <button class="btn btn-primary" type="submit">{{ sitecore.betslip.wallet.WalletSelectorConfirm }}</button>
        </div>
        <div class="wallet-selector-footer">
            <div class="wallet-selector-dont-show-again">
                <ds-checkbox name="dontShowAgain" size="medium" ngDefaultControl [(ngModel)]="doNotShowAgain">{{
                    sitecore.betslip.wallet.WalletSelectorDoNotShowAgain
                }}</ds-checkbox>
            </div>
            @if (walletSelectorHelpUrl) {
                <div>
                    <a class="wallet-selector-help" [href]="walletSelectorHelpUrl" target="{{ nativeAppService.isNative ? '' : '_blank' }}">{{
                        sitecore.betslip.wallet.WalletSelectorHelpText
                    }}</a>
                </div>
            }
        </div>
    </form>
</div>
